<mat-label class="subHeading"
  >UIN No.<span *ngIf="isRequired" class="star">*</span></mat-label
>
<input formControlName="uin_no" type="text" class="rule mt-2" />
